// Controls the "Добавьте Humanteq на главный экран" popup shown right after
// registration and after a successful payment. requestShow() only opens it on
// mobile devices that don't already have the PWA installed.
import { create } from 'zustand'
import { isMobileDevice, isStandalonePwa } from '../lib/install'
import { useNotifyPromptStore } from './notifyPromptStore'

interface InstallGuideState {
  open: boolean
  pending: boolean
  // True once the guide has actually opened this session (not merely queued).
  // In-memory only — the InstallPrompt banner reads it to avoid nudging the user
  // to install right after this popup already did. Resets on reload, by design.
  shownThisSession: boolean
  requestShow: () => void
  flushPending: () => void
  close: () => void
}

export const useInstallGuideStore = create<InstallGuideState>()((set, get) => ({
  open: false,
  pending: false,
  shownThisSession: false,
  requestShow: () => {
    if (!isMobileDevice() || isStandalonePwa()) return
    // Both prompts can be requested back-to-back right after registration
    // (see useOnboardingGate.js/Onboarding.jsx). Queue instead of opening
    // immediately if the notification prompt already claimed the overlay
    // slot, so the two never stack — NotificationPrompt flushes the queue
    // once it closes, showing this one right after (task requires it to
    // appear after registration, just not simultaneously).
    if (useNotifyPromptStore.getState().open) {
      set({ pending: true })
      return
    }
    set({ open: true, shownThisSession: true })
  },
  // Called by NotificationPrompt once it closes.
  flushPending: () => {
    if (get().pending) set({ open: true, pending: false, shownThisSession: true })
  },
  close: () => set({ open: false }),
}))
